import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WinnipegsCleanAirAuthority from "./sections/WinnipegsCleanAirAuthority";
import WhyChooseTrustedInspections from "./sections/WhyChooseTrustedInspections";
import ProfessionalPlumbingSolutions from "./sections/ProfessionalPlumbingSolutions";
import OurInspectionProcess from "./sections/OurInspectionProcess";
import HowItWorks from "./sections/HowItWorks";
import TheTrustedInspectionsAdvantage from "./sections/TheTrustedInspectionsAdvantage";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import ServiceAreas from "./sections/ServiceAreas";
import ReachOutToTheShop from "./sections/ReachOutToTheShop";
import CompanyDirectory from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WinnipegsCleanAirAuthority />
      <WhyChooseTrustedInspections />
      <ProfessionalPlumbingSolutions />
      <OurInspectionProcess />
      <HowItWorks />
      <TheTrustedInspectionsAdvantage />
      <ClientSuccessStories />
      <ServiceAreas />
      <ReachOutToTheShop />
      <CompanyDirectory />
    </div>;
}